// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './Header';
import {
  setActiveSection,
  MERCHANTS,
  PARTNERS,
  resetReferralsState
} from './reducer';
import { ReferralsDiv } from './ReferralsStyles';
import { loadDirectMerchants } from '../../Merchants/DirectMerchants/DirectMerchantsIndex/reducer/directMerchants';
import Partners from './Partners';
import Merchants from './Merchants';
type Props = {
  activeSection: string,
  setActiveSection: (section: string) => void,
  resetReferralsState: () => void,
  loadDirectMerchants: () => void,
  resetReferralsState: () => void,
  total_users: number,
  flippers: {
    partner_referrals: boolean
  }
};

class Referrals extends Component<Props> {
  componentDidMount() {
    this.props.loadDirectMerchants();
  }
  componentWillUnmount() {
    this.props.resetReferralsState();
  }
  render() {
    return (
      <ReferralsDiv>
        <Header
          activeSection={this.props.activeSection}
          setActiveSection={this.props.setActiveSection}
          total_users={this.props.total_users}
          flippers={this.props.flippers}
        />
        {this.props.activeSection === MERCHANTS && <Merchants />}
        {this.props.activeSection === PARTNERS && <Partners />}
      </ReferralsDiv>
    );
  }
}

const mapStateToProps = state => ({
  activeSection: state.dashboard.referrals.activeSection,
  total_users:
    state.merchants.directMerchants.index.directMerchants.total_users,
  flippers: state.global.flippers
});

const mapDispatchToProps = {
  setActiveSection,
  loadDirectMerchants,
  resetReferralsState
};

export default connect(mapStateToProps, mapDispatchToProps)(Referrals);
